import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { RecordInsightPage } from '~/features/insights/insight-page';

/** One of a record's insights on its own page (board "Daily sales · Sales by day, opened"). */
function InsightRoute(): ReactElement {
  const { recordId, cardId } = Route.useParams();
  return <RecordInsightPage key={`${recordId}-${cardId}`} recordId={recordId} cardId={cardId} />;
}

export const Route = createFileRoute('/_app/records/$recordId/insights/$cardId/')({ component: InsightRoute });
